import { createSlice } from "@reduxjs/toolkit";

export const serviceTypeSlice = createSlice({
  name: "serviceType",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    serviceTypeList: [],
    model: false,
    error_msg: null,
    rowdata: {},
    listCount: 0,
    serviceTypeParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getServiceTypes: (state) => {
      return { ...state, loading: true };
    },
    serviceTypeListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.serviceTypeParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        serviceTypeList: action.payload.response.results,
        loading: false,
        serviceTypeParams: {
          ...state.serviceTypeParams,
          no_of_pages: noofpages,
        },
      };
    },
    serviceTypeAdd: (state) => {
      return { ...state, loading: true };
    },
    serviceTypeAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    serviceTypeEdit: (state, action) => {
      return { ...state, model: true, rowdata: action.payload };
    },
    serviceTypeEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    serviceTypeDelete: (state) => {
      return { ...state, loading: false };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return { ...state, model: action.payload, rowdata: {} };
      } else {
        return { ...state, model: action.payload };
      }
    },
    SetServiceTypeParams: (state, action) => {
      return { ...state, serviceTypeParams: action.payload };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

export const {
  getServiceTypes,
  serviceTypeListSuccessful,
  serviceTypeAdd,
  serviceTypeAddSuccessful,
  serviceTypeEdit,
  serviceTypeEditSuccessful,
  serviceTypeDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetServiceTypeParams,
} = serviceTypeSlice.actions;

export default serviceTypeSlice.reducer;
